import axios from 'axios';
import { CareHome, SearchRequest } from '../types';

const API_BASE_URL = import.meta.env.PROD ? '' : 'http://localhost:3001';

class ApiService {
    private axiosInstance;

    constructor() {
        this.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            timeout: 10000,
        });
    }

    async searchCareHomes(searchRequest: SearchRequest): Promise<{
        success: boolean;
        data: CareHome[];
        count: number;
        searchCenter: { latitude: number; longitude: number };
    }> {
        try {
            const response = await this.axiosInstance.post('/api/search', searchRequest);
            return response.data;
        } catch (error) {
            console.error('Search API error:', error);
            throw new Error('Failed to search care homes');
        }
    }

    async searchByCareHomeId(id: string): Promise<{
        success: boolean;
        data: CareHome[];
        count: number;
        searchCenter: { latitude: number; longitude: number; postcode: string };
        radiusMiles: number;
    }> {
        try {
            const response = await this.axiosInstance.post('/api/search', { id });
            return response.data;
        } catch (error) {
            console.error('Search by ID API error:', error);
            throw new Error('Failed to search care homes by ID');
        }
    }

    async healthCheck(): Promise<{ status: string; timestamp: string; service: string }> {
        try {
            const response = await this.axiosInstance.get('/api/health');
            return response.data;
        } catch (error) {
            console.error('Health check API error:', error);
            throw new Error('Health check failed');
        }
    }

    /**
     * Track user action (click on Details, Contact, or Manage links)
     * Fire-and-forget - does not block user navigation
     * @param params Action tracking parameters
     */
    trackUserAction(params: {
        regulator_id: string;
        user_action: 'details' | 'contact' | 'manage';
        user_id: string;
        starting_post_code: string;
        search_position: number;
    }): void {
        // Fire-and-forget - don't await, don't block user interaction
        this.axiosInstance.post('/api/action', params)
            .then(() => {
                console.log(`🖱️ Action tracked: ${params.user_action} for ${params.regulator_id}`);
            })
            .catch((error) => {
                // Log error but don't disrupt user experience
                console.error('Failed to track user action:', error);
            });
    }
}

export default new ApiService(); 